import { render, staticRenderFns } from "./admin-contests-requests.vue?vue&type=template&id=20ec69c5&lang=pug&"
import script from "./admin-contests-requests.vue?vue&type=script&lang=js&"
export * from "./admin-contests-requests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports